import { gql } from '@apollo/client';

import {
  COMPANY_PAGINATION_DATA_FRAGMENT,
  COMPANY_BASIC_RESULTS_FRAGMENT,
} from 'graphql/company/fragments';
import {
  USER_BASIC_FIELDS,
  ID_NAME_FIELDS,
  PROPERTY_MAIN_FIELDS,
} from 'graphql/common/fragments';

export const COMPANY_DETAILS = gql`
  query companyDetails($id: ID!) {
    companyDetails(id: $id) {
      leases
      properties
      sales
      tims
    }
  }
`;

export const COMPANY_TRANSACTION_VOLUME_QUERY = gql`
  query companyTransactionVolume($search: CompanyTransactionVolumeInput) {
    companyTransactionVolume(search: $search) {
      year
      valuePurchased
      countPropertiesPurchased
      totalSFPurchased
      totalSquareMetersPurchased
      valueSold
      countPropertiesSold
      totalSFSold
      totalSquareMetersSold
      currencyCode
      measurementSystem
    }
  }
`;

export const GET_COMPANY_QUERY = gql`
  query getCompany($id: ID!) {
    company(id: $id) {
      ...companyBasicResults
      comments
      logoId
      naics {
        id
        twoDigitCode
        twoDigitName
        fourDigitCode
        fourDigitName
      }
      headquarterProperty {
        ${PROPERTY_MAIN_FIELDS}
      }
      investorType {
        ${ID_NAME_FIELDS}
      }
      createdUser {
        ${USER_BASIC_FIELDS}
      }
      updatedUser {
        ${USER_BASIC_FIELDS}
      }
      parentCompanyId
      childCompanies {
        ...companyBasicResults
      }
      parentCompany {
        ...companyBasicResults
      }
      legalName
      createdAt
      updatedAt
      operatingName
      stockCode
      linkedIn
    }
  }
  ${COMPANY_BASIC_RESULTS_FRAGMENT}
`;

export const SEARCH_COMPANIES_QUERY = gql`
  query companies($search: CompanySearchInput!) {
    companies(search: $search) {
      ...companyPaginationData
      results {
        ...companyBasicResults
      }
    }
  }
  ${COMPANY_PAGINATION_DATA_FRAGMENT}
  ${COMPANY_BASIC_RESULTS_FRAGMENT}
`;

export const COMPANIES_MERGED_QUERY = gql`
  query companiesMerged($companyId: Int!) {
    companiesMerged(companyId: $companyId) {
      ...companyBasicResults
    }
  }
  ${COMPANY_BASIC_RESULTS_FRAGMENT}
`;

export const COMPANY_INVESTOR_TYPES = gql`
  query investorTypes {
    investorTypes {
      ${ID_NAME_FIELDS}
    }
  }
`;

export const NAICS_SEARCH = gql`
  query naicsSearch($search: String!) {
    naicsSearch(search: $search) {
      id
      twoDigitCode
      twoDigitName
      fourDigitCode
      fourDigitName
    }
  }
`;
